export default __webpack_public_path__ + "static/media/imagePickAndPackContentThree.ae021815.png";